export default "__VITE_ASSET__1fa99337__"